module.exports = __webpack_public_path__ + "static/media/export-icon.a29817e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/export-icon.svg
// module id = 2235
// module chunks = 0